import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject } from '@angular/core';
import { PythonTestCaseComponent } from '../python-test-case/python-test-case';

@Component({
  selector: 'skypro-python-test-case-output',
  template: `
    <div [hidden]="true">
      <ng-content></ng-content>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PythonTestCaseOutputComponent implements AfterViewInit {
  private pythonTestCaseComponent = inject(PythonTestCaseComponent);
  private elementRef = inject(ElementRef<HTMLElement>);

  ngAfterViewInit(): void {
    const output = this.elementRef.nativeElement.textContent?.trim() || '';
    this.pythonTestCaseComponent.addOutput(output);
  }
}
